import axios from "axios";

export type ApiTokenId = string & { __brand: "ApiTokenId" };

export type ApiToken = {
    id: ApiTokenId;
    name: string;
    prefix: string;
    createdAt: string;
    lastUsedAt: string | null;
    expiresAt: string | null;
};

export type CreatedApiToken = ApiToken & { token: string };

export type TokenApi = {
    getTokens(): Promise<ApiToken[]>;

    create(name: string, expiresAt?: string): Promise<CreatedApiToken>;

    revoke(token: ApiTokenId): Promise<void>;
};

export const tokenApi: TokenApi = {
    async getTokens() {
        const { data: tokens } = await axios.get<ApiToken[]>(`/api/v0/auth/tokens`);

        return tokens;
    },

    async create(name, expiresAt) {
        const { data: token } = await axios.post<CreatedApiToken>(`/api/v0/auth/tokens`, {
            name,
            expiresAt: expiresAt ?? null,
        });

        return token;
    },

    async revoke(token) {
        await axios.delete(`/api/v0/auth/tokens/${token}`);
    },
};
